
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/hr-privacy",
      function () {
        return require("private-next-pages/services/hr-privacy.tsx");
      }
    ]);
  